/* eslint-disable max-len */
import { tryGetHostApi } from "../../../app/externalApi/externalApi";
import { Measures } from "../../../telemetry/Measures";
import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
import * as Constants from "../../constants";
import { getFeedProviderHostApi } from "../../externalApi/FeedProviderHostApi";
import { addSystemThemeChangedEventListener, getSystemTheme } from "../../externalApi/ThemeApi";
import { isFeatureEnabled } from "../../externalApi/VelocityApi";
import { getResources } from "../../getResources";
import { deepCompare } from "../../utils/objectCompareUtilities";
export const widgetsBoardId = "com.msn.widgetsboard";
const widgetsBoardIconDark = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjQ5MjMgMS4zMzA0TDE4LjY3MSA0LjUwOTE3QzE5LjU0OTcgNS4zODc4NSAxOS41NDk3IDYuODEyNDcgMTguNjcxIDcuNjkxMTVMMTYuMDg2NiAxMC4yNzUxQzE3LjE2OTYgMTAuNDM3NSAxOCAxMS4zNzE4IDE4IDEyLjUwMDFWMTcuNzUwMUMxOCAxOC45OTI3IDE2Ljk5MjYgMjAuMDAwMSAxNS43NSAyMC4wMDAxSDIuMjVDMS4wMDczNiAyMC4wMDAxIDAgMTguOTkyNyAwIDE3Ljc1MDFWNC4yNTAwN0MwIDMuMDA3NDMgMS4wMDczNiAyLjAwMDA3IDIuMjUgMi4wMDAwN0g3LjVDOC42Mjg5NCAyLjAwMDA3IDkuNTYzNjkgMi44MzE1MiA5LjcyNTI5IDMuOTE1NDdMMTIuMzEwMyAxLjMzMDRDMTMuMTg5IDAuNDUxNzE3IDE0LjYxMzYgMC40NTE3MTcgMTUuNDkyMyAxLjMzMDRaTTEuNSAxNy43NTAxQzEuNSAxOC4xNjQzIDEuODM1NzkgMTguNTAwMSAyLjI1IDE4LjUwMDFMOC4yNDkgMTguNDk5NEw4LjI1IDExLjc1MDFMMS41IDExLjc0OTRWMTcuNzUwMVpNOS43NDkgMTguNDk5NEwxNS43NSAxOC41MDAxQzE2LjE2NDIgMTguNTAwMSAxNi41IDE4LjE2NDMgMTYuNSAxNy43NTAxVjEyLjUwMDFDMTYuNSAxMi4wODU5IDE2LjE2NDIgMTEuNzUwMSAxNS43NSAxMS43NTAxTDkuNzQ5IDExLjc0OTRWMTguNDk5NFpNNy41IDMuNTAwMDdIMi4yNUMxLjgzNTc5IDMuNTAwMDcgMS41IDMuODM1ODUgMS41IDQuMjUwMDdWMTAuMjQ5NEg4LjI1VjQuMjUwMDdDOC4yNSAzLjgzNTg1IDcuOTE0MjEgMy41MDAwNyA3LjUgMy41MDAwN1pNOS43NSA4LjMwOTM5VjEwLjI1MDFMMTEuNjkgMTAuMjQ5NEw5Ljc1IDguMzA5MzlaTTEzLjM3MDkgMi4zOTEwNkwxMC4xOTIyIDUuNTY5ODNDOS44OTkyNyA1Ljg2MjcyIDkuODk5MjcgNi4zMzc1OSAxMC4xOTIyIDYuNjMwNDlMMTMuMzcwOSA5LjgwOTI2QzEzLjY2MzggMTAuMTAyMiAxNC4xMzg3IDEwLjEwMjIgMTQuNDMxNiA5LjgwOTI2TDE3LjYxMDQgNi42MzA0OUMxNy45MDMzIDYuMzM3NTkgMTcuOTAzMyA1Ljg2MjcyIDE3LjYxMDQgNS41Njk4M0wxNC40MzE2IDIuMzkxMDZDMTQuMTM4NyAyLjA5ODE2IDEzLjY2MzggMi4wOTgxNiAxMy4zNzA5IDIuMzkxMDZaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjU0NDIiLz4KPC9zdmc+";
const widgetsBoardIconLight = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjQ5MjMgMS4zMzA0TDE4LjY3MSA0LjUwOTE3QzE5LjU0OTcgNS4zODc4NSAxOS41NDk3IDYuODEyNDcgMTguNjcxIDcuNjkxMTVMMTYuMDg2NiAxMC4yNzUxQzE3LjE2OTYgMTAuNDM3NSAxOCAxMS4zNzE4IDE4IDEyLjUwMDFWMTcuNzUwMUMxOCAxOC45OTI3IDE2Ljk5MjYgMjAuMDAwMSAxNS43NSAyMC4wMDAxSDIuMjVDMS4wMDczNiAyMC4wMDAxIDAgMTguOTkyNyAwIDE3Ljc1MDFWNC4yNTAwN0MwIDMuMDA3NDMgMS4wMDczNiAyLjAwMDA3IDIuMjUgMi4wMDAwN0g3LjVDOC42Mjg5NCAyLjAwMDA3IDkuNTYzNjkgMi44MzE1MiA5LjcyNTI5IDMuOTE1NDdMMTIuMzEwMyAxLjMzMDRDMTMuMTg5IDAuNDUxNzE3IDE0LjYxMzYgMC40NTE3MTcgMTUuNDkyMyAxLjMzMDRaTTEuNSAxNy43NTAxQzEuNSAxOC4xNjQzIDEuODM1NzkgMTguNTAwMSAyLjI1IDE4LjUwMDFMOC4yNDkgMTguNDk5NEw4LjI1IDExLjc1MDFMMS41IDExLjc0OTRWMTcuNzUwMVpNOS43NDkgMTguNDk5NEwxNS43NSAxOC41MDAxQzE2LjE2NDIgMTguNTAwMSAxNi41IDE4LjE2NDMgMTYuNSAxNy43NTAxVjEyLjUwMDFDMTYuNSAxMi4wODU5IDE2LjE2NDIgMTEuNzUwMSAxNS43NSAxMS43NTAxTDkuNzQ5IDExLjc0OTRWMTguNDk5NFpNNy41IDMuNTAwMDdIMi4yNUMxLjgzNTc5IDMuNTAwMDcgMS41IDMuODM1ODUgMS41IDQuMjUwMDdWMTAuMjQ5NEg4LjI1VjQuMjUwMDdDOC4yNSAzLjgzNTg1IDcuOTE0MjEgMy41MDAwNyA3LjUgMy41MDAwN1pNOS43NSA4LjMwOTM5VjEwLjI1MDFMMTEuNjkgMTAuMjQ5NEw5Ljc1IDguMzA5MzlaTTEzLjM3MDkgMi4zOTEwNkwxMC4xOTIyIDUuNTY5ODNDOS44OTkyNyA1Ljg2MjcyIDkuODk5MjcgNi4zMzc1OSAxMC4xOTIyIDYuNjMwNDlMMTMuMzcwOSA5LjgwOTI2QzEzLjY2MzggMTAuMTAyMiAxNC4xMzg3IDEwLjEwMjIgMTQuNDMxNiA5LjgwOTI2TDE3LjYxMDQgNi42MzA0OUMxNy45MDMzIDYuMzM3NTkgMTcuOTAzMyA1Ljg2MjcyIDE3LjYxMDQgNS41Njk4M0wxNC40MzE2IDIuMzkxMDZDMTQuMTM4NyAyLjA5ODE2IDEzLjY2MzggMi4wOTgxNiAxMy4zNzA5IDIuMzkxMDZaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjQ0NTgiLz4KPC9zdmc+Cg==";
export class FeedModelApi {
    constructor() {
        this._feedProviderApi = null;
        this._selectedPivot = undefined;
        this._activeFeedsOrder = [];
        this._isDarkTheme = false;
        this._feedEventListeners = new Array();
        this._feedProviderEventListeners = new Array();
        this._feedRegistrations = new Map();
        this._feedProviderRegistrations = new Map();
    }
    async initializeAsync() {
        var _a;
        let selectedPivot = window.localStorage.getItem("selectedPivot");
        if (!selectedPivot) {
            // First run only when selected pivot is undefined select the start board,
            // otherwise the widgets board is selected since it is first in the list.
            selectedPivot = Constants.StartBoardId;
        }
        let activeFeedsOrder = window.localStorage.getItem("activeFeedsOrder");
        if (activeFeedsOrder) {
            this._activeFeedsOrder = JSON.parse(activeFeedsOrder);
        }
        this._isDarkTheme = await this.isDarkThemeAsync();
        addSystemThemeChangedEventListener(this.updateSystemTheme.bind(this));
        this._feedProviderApi = await getFeedProviderHostApi();
        // During initalization there will be no event listeners so there is no need to block them during updates
        let [feedProviders, enabledProviders] = await Promise.all([
            this.getHostFeedProvidersAsync(),
            this.getHostEnabledFeedProvidersAsync(),
        ]);
        for (const feedProvider of feedProviders) {
            // Initialize the enabled state of the provider
            let enabled = enabledProviders.some((feedProviderDefinitionId) => feedProviderDefinitionId === feedProvider.id);
            // These can't be run in parallel.  If the second runs before the first, the first may overwrite the state of the provider.
            await this.updateFeedProviderAsync(feedProvider);
            await this.setFeedProviderEnabledStateAsync(feedProvider.id, enabled);
        }
        // Add the widgets board provider/feed after real platform providers so we don't attempt to fetch details about it from the widget service
        // !!! Only under boards Feature_BoardsLite
        // Push or unshift depending on spec placement of first or last
        if (isFeatureEnabled("Feature_BoardsLite")) {
            await this.AddWidgetsBoard();
        }
        if (this._feedProviderApi) {
            this._feedProviderApi.addEventListener("registrationAdded", this.onRegistrationAddedAsync.bind(this));
            this._feedProviderApi.addEventListener("registrationRemoved", this.onRegistrationRemoved.bind(this));
            this._feedProviderApi.addEventListener("registrationChanged", this.onRegistrationChangedAsync.bind(this));
        }
        if (isFeatureEnabled("Feature_3PAEP")) {
            (_a = this._feedProviderApi) === null || _a === void 0 ? void 0 : _a.addEventListener("missedNotificationsChanged", this.onMissedNotificationsChanged.bind(this));
        }
        // Ensure the selected pivot still exists, otherwise select the first one
        let enabledFeeds;
        if (selectedPivot && this.getFeedRegistration(selectedPivot) !== undefined) {
            this.setSelectedFeedPivotHelper(selectedPivot);
        }
        else if ((enabledFeeds = this.getEnabledFeeds()).length > 0) {
            // Select the first feed that is enabled
            this.setSelectedFeedPivotHelper(enabledFeeds[0].id);
        }
        else {
            this.setSelectedFeedPivotHelper("");
        }
        this.SendActiveProviderToHost(this._selectedPivot);
        if (this._selectedPivot && !this._activeFeedsOrder.includes(this._selectedPivot)) {
            this._activeFeedsOrder.push(this._selectedPivot);
            window.localStorage.setItem("activeFeedsOrder", JSON.stringify(this._activeFeedsOrder));
        }
    }
    // Called from settings UI to enable or disable a specific provider which will result in added/removed events
    async setFeedProviderEnabledStateAsync(feedProviderDefinitionId, enabled) {
        let feedProviderRegistration = this._feedProviderRegistrations.get(feedProviderDefinitionId);
        if (feedProviderRegistration) {
            feedProviderRegistration.enabled = enabled;
            // Tell the host the new state
            await Promise.all([
                // Update the listeners for the effect
                await this.updateFeedProviderAsync(feedProviderRegistration),
                await this.enableHostFeedProviderAsync(feedProviderDefinitionId, enabled),
            ]);
        }
    }
    // Called from settings UI to enable or disable a specific provider which will result in added/removed events
    async setFeedNotificationEnabledStateAsync(feedProviderDefinitionId, feedDefinitionId, enabled) {
        let feed = [...this._feedRegistrations.values()].find((registration) => {
            return registration.providerId === feedProviderDefinitionId && registration.id === feedDefinitionId;
        });
        if (feed) {
            feed.notifications = enabled;
            // Tell the host the new state
            await Promise.all([
                // Update the listeners for the effect
                await this.setFeedNotificationsEnabledAsync(feedProviderDefinitionId, feedDefinitionId, enabled),
            ]);
        }
    }
    feedProviderIsEnabled(feedProviderDefinitionId) {
        let feedProviderRegistration = this._feedProviderRegistrations.get(feedProviderDefinitionId);
        if (feedProviderRegistration) {
            return feedProviderRegistration.enabled;
        }
        return false;
    }
    // Get the list of active provider registrations both enabled and disabled
    getFeedProviders() {
        return [...this._feedProviderRegistrations.values()];
    }
    // DEPRECATED
    async getEnabledFeedsAsync() {
        return this.getEnabledFeeds();
    }
    // Get the list of registrations for all feeds across all providers that are enabled
    getEnabledFeeds() {
        let feeds = [...this._feedRegistrations.values()].filter((registration) => {
            return this.feedProviderIsEnabled(registration.providerId);
        });
        // sort feeds as per active feeds order.
        let sortedFeeds = feeds.slice().sort((a, b) => {
            if (a.id === widgetsBoardId) {
                return -1; // -1 for always first, 1 for always last
            }
            else {
                return this._activeFeedsOrder.indexOf(a.id) - this._activeFeedsOrder.indexOf(b.id);
            }
        });
        return sortedFeeds;
    }
    // Get the list of regisrations for all feeds sorted alphabetically
    getEnabledFeedOrderByProvider() {
        let feedProviders = this.getFeedProviders();
        let feeds = [...this._feedRegistrations.values()];
        let sortedFeeds = feeds.slice().sort((a, b) => {
            if (a.providerId == b.providerId) {
                return a.displayName.localeCompare(b.displayName);
            }
            else {
                var aProvider = feedProviders.find((provider) => { return provider.id === a.providerId; });
                var bProvider = feedProviders.find((provider) => { return provider.id === b.providerId; });
                if (!!aProvider && !!bProvider) {
                    return aProvider.displayName.localeCompare(bProvider.displayName);
                }
                else {
                    return 1; // Always place an errored element at the end.
                }
            }
        });
        return sortedFeeds;
    }
    // DEPRECATED
    async getFeedRegistrationAsync(feedDefinitionId) {
        return this.getFeedRegistration(feedDefinitionId);
    }
    // Get the definition for a single feed object
    getFeedRegistration(feedDefinitionId) {
        if (this._feedRegistrations.has(feedDefinitionId)) {
            return this._feedRegistrations.get(feedDefinitionId);
        }
        return undefined;
    }
    // DEPRECATED
    async getFeedProviderRegistrationAsync(feedProviderDefinitionId) {
        return this.getFeedProviderRegistration(feedProviderDefinitionId);
    }
    // Get the definition for a single feed provider object
    getFeedProviderRegistration(feedProviderDefinitionId) {
        if (this._feedProviderRegistrations.has(feedProviderDefinitionId)) {
            return this._feedProviderRegistrations.get(feedProviderDefinitionId);
        }
        return undefined;
    }
    // WebXT should call this when a pivot is selected.
    setSelectedFeedPivot(id) {
        const registration = this.setSelectedFeedPivotHelper(id);
        if (registration !== undefined) {
            Measures.logEvent(dashboard, "WidgetFeedHeaderClicked", 16777216 /* productAndServicePerformance */, {
                appId: registration === null || registration === void 0 ? void 0 : registration.appId,
                displayName: registration === null || registration === void 0 ? void 0 : registration.displayName,
                provider: registration === null || registration === void 0 ? void 0 : registration.providerId,
            });
        }
    }
    // Reusable logic for internal pivot changing, without sending telemetry.
    setSelectedFeedPivotHelper(id) {
        if (this._selectedPivot !== id) {
            this._selectedPivot = id;
            window.localStorage.setItem("selectedPivot", id);
            this.SendActiveProviderToHost(this._selectedPivot);
            return this.getFeedRegistration(id);
        }
        return undefined;
    }
    // DEPRECATED
    async getSelectedFeedPivotAsync() {
        return this.getSelectedFeedPivot();
    }
    // WebXT should call this on startup.
    getSelectedFeedPivot() {
        return this._selectedPivot;
    }
    addFeedEventListener(listener) {
        this._feedEventListeners.push(listener);
    }
    removeFeedEventListener(listener) {
        let index = this._feedEventListeners.indexOf(listener);
        if (index > -1) {
            this._feedEventListeners.splice(index, 1);
        }
    }
    addFeedProviderEventListener(listener) {
        this._feedProviderEventListeners.push(listener);
    }
    removeFeedProviderEventListener(listener) {
        let index = this._feedProviderEventListeners.indexOf(listener);
        if (index > -1) {
            this._feedProviderEventListeners.splice(index, 1);
        }
    }
    async isDarkThemeAsync() {
        const theme = await getSystemTheme();
        const systemBackgroundColor = theme.substr(0, 6);
        return (systemBackgroundColor === "000000");
    }
    // Private host event handlers
    async updateSystemTheme() {
        // Update the built in widgets board registration
        this._isDarkTheme = await this.isDarkThemeAsync();
        // Re-add the widgets board, the registration will be updated
        await this.AddWidgetsBoard();
        this.notifyFeedProviderModelEvent("changed", widgetsBoardId);
        this.notifyFeedModelEvent("changed", [widgetsBoardId]);
        // Cause the rest of the registrations to be re-serizlized as if they were 'changed"
        [...this._feedProviderRegistrations.keys()].map((registrationId) => {
            if (registrationId !== widgetsBoardId) {
                this.onRegistrationChangedAsync(registrationId);
            }
        });
    }
    // Host event handlers
    async onRegistrationAddedAsync(feedProviderDefinitionId) {
        let feedProviderRegistration = await this.getHostFeedProviderAsync(feedProviderDefinitionId);
        if (feedProviderRegistration) {
            feedProviderRegistration.enabled = true;
            this._feedProviderRegistrations.set(feedProviderDefinitionId, feedProviderRegistration);
            // Update the listeners for the effect
            await this.updateFeedProviderAsync(feedProviderRegistration);
        }
    }
    onRegistrationRemoved(feedProviderDefinitionId) {
        let removedRegistrations = new Array();
        // Identify all feed registrations that are removed and remain
        // For each feed registion...
        [...this._feedRegistrations.values()].map((feedRegistration) => {
            // If this feed registration is from the removed provider add it to the removed list
            if (feedRegistration.providerId === feedProviderDefinitionId) {
                removedRegistrations.push(feedRegistration.id);
            }
        });
        // Update registrations and notify listeners of the feeds that were removed
        if (removedRegistrations.length) {
            removedRegistrations.forEach((registration) => {
                this._feedRegistrations.delete(registration);
                this._activeFeedsOrder = this._activeFeedsOrder.filter((id) => id !== registration);
            });
            window.localStorage.setItem("activeFeedsOrder", JSON.stringify(this._activeFeedsOrder));
            this.notifyFeedModelEvent("removed", removedRegistrations);
        }
        this._feedProviderRegistrations.delete(feedProviderDefinitionId);
        this.notifyFeedProviderModelEvent("removed", feedProviderDefinitionId);
        let feedIds = this.getEnabledFeeds().map((feedRegistration) => feedRegistration.id);
        // Report the list of enabled feeds even when empty
        this.notifyFeedModelEvent("listChanged", feedIds);
    }
    async onRegistrationChangedAsync(feedProviderDefinitionId) {
        // Get the registration string from the host and call updateFeedProvider
        let registration = await this.getHostFeedProviderAsync(feedProviderDefinitionId);
        if (registration) {
            await this.updateFeedProviderAsync(registration);
        }
    }
    async onMissedNotificationsChanged(feedDefinitionId) {
        // Get the missed notification(s) and update the corresponding feed in cache.
        if (this._feedRegistrations.has(feedDefinitionId)) {
            const feed = this._feedRegistrations.get(feedDefinitionId);
            if (feed) {
                const missedNotifications = await this.getHostMissedFeedNotificationsAsync(feedDefinitionId);
                feed.missedNotifications = missedNotifications;
                this._feedRegistrations.set(feed.id, feed);
                this.notifyFeedModelEvent("missedNotificationsChanged", [feed.id]);
            }
        }
    }
    // Host Api Wrappers
    // Uses host api GetEnabledFeedProvidersAsync(callback: (hresult: number, feedProviderDefinitionIds: Array<string>) => void): Promise<void>;
    async getHostEnabledFeedProvidersAsync() {
        if (this._feedProviderApi) {
            // Fetch the feed provider id's that are enabled
            return new Promise(async (resolve) => {
                var _a;
                await ((_a = this._feedProviderApi) === null || _a === void 0 ? void 0 : _a.GetEnabledFeedProvidersAsync((hresult, feedDefinitionIds) => {
                    if (hresult !== 0) {
                        Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                            hresult: hresult,
                            reason: "GetEnabledFeedProvidersAsync failed",
                        });
                        resolve([]);
                    }
                    resolve(feedDefinitionIds);
                }));
            });
        }
        return [];
    }
    // Uses host api GetFeedProvidersAsync(callback: (hresult: number, feedProviderDefinitions: Array<string>) => void): Promise<void>;
    // returns an array of feed provider registration string
    async getHostFeedProvidersAsync() {
        if (this._feedProviderApi) {
            // Fetch the feed provider id's that are enabled
            return new Promise(async (resolve) => {
                var _a;
                await ((_a = this._feedProviderApi) === null || _a === void 0 ? void 0 : _a.GetFeedProvidersAsync((hresult, feedProviderDefinitions) => {
                    if (hresult !== 0) {
                        Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                            hresult: hresult,
                            reason: "GetFeedProvidersAsync failed",
                        });
                        resolve([]);
                    }
                    let feedProviders = new Array();
                    feedProviderDefinitions.map((feedProviderDefinitionString) => {
                        let feedProvider = null;
                        try {
                            feedProvider = JSON.parse(feedProviderDefinitionString);
                            if (feedProvider) {
                                feedProvider.canBeDisabled = true;
                                feedProviders.push(feedProvider);
                            }
                        }
                        catch (ex) {
                            Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                                exception: ex,
                                reason: "GetFeedProvidersAsync unparsable json",
                            });
                            resolve([]);
                        }
                    });
                    resolve(feedProviders);
                }));
            });
        }
        return [];
    }
    // Uses host api GetFeedProviderAsync(feedProviderId: string, callback: (hresult: number, feedProviderDefinition: string) => void): Promise<void>;
    // Returns a single feed provider registration string
    async getHostFeedProviderAsync(feedProviderDefinitionId) {
        if (this._feedProviderApi) {
            // Fetch the feed provider id's that are enabled
            return new Promise(async (resolve) => {
                var _a;
                await ((_a = this._feedProviderApi) === null || _a === void 0 ? void 0 : _a.GetFeedProviderAsync(feedProviderDefinitionId, (hresult, feedProviderDefinitionString) => {
                    if (hresult !== 0) {
                        Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                            feedProviderDefinitionId: feedProviderDefinitionId,
                            hresult: hresult,
                            reason: "GetFeedProviderAsync failed",
                        });
                        resolve(null);
                    }
                    let feedProvider = null;
                    try {
                        feedProvider = JSON.parse(feedProviderDefinitionString);
                        if (feedProvider) {
                            feedProvider.canBeDisabled = true;
                        }
                    }
                    catch (ex) {
                        Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                            exception: ex,
                            feedProviderDefinitionId: feedProviderDefinitionId,
                            reason: "GetFeedProviderAsync unparsable json",
                        });
                        resolve(null);
                    }
                    resolve(feedProvider);
                }));
            });
        }
        return null;
    }
    // Uses host api GetFeedsAsync(feedProviderId: string, callback: (hresult: number, feedDefinitions: Array<string>) => void): Promise<void>;
    async getHostFeedsAsync(feedProviderDefinitionId) {
        if (this._feedProviderApi) {
            // Fetch the feed provider id's that are enabled
            return new Promise(async (resolve) => {
                var _a;
                await ((_a = this._feedProviderApi) === null || _a === void 0 ? void 0 : _a.GetFeedsAsync(feedProviderDefinitionId, (hresult, feedDefinitions) => {
                    if (hresult !== 0) {
                        Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                            hresult: hresult,
                            reason: "GetFeedsAsync failed",
                        });
                        resolve([]);
                    }
                    let feeds = new Array();
                    feedDefinitions.map((feedDefinitionString) => {
                        let feed = null;
                        try {
                            feed = JSON.parse(feedDefinitionString);
                            if (feed) {
                                feeds.push(feed);
                            }
                        }
                        catch (ex) {
                            Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                                exception: ex,
                                feedProviderDefinitionId: feedProviderDefinitionId,
                                reason: "GetFeedsAsync unparsable json",
                            });
                        }
                    });
                    resolve(feeds);
                }));
            });
        }
        return [];
    }
    // Private internal methods
    async getHostMissedFeedNotificationsAsync(feedDefinitionId) {
        if (this._feedProviderApi && isFeatureEnabled("Feature_3PAEP")) {
            // Fetch the feed provider id's that are enabled
            return new Promise(async (resolve) => {
                var _a;
                await ((_a = this._feedProviderApi) === null || _a === void 0 ? void 0 : _a.GetMissedFeedNotificationsAsync(feedDefinitionId, (hresult, missedNotificationsFromHost) => {
                    if (hresult !== 0) {
                        Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                            hresult: hresult,
                            reason: "GetMissedFeedNotificationsAsync failed",
                        });
                        resolve([]);
                    }
                    let missedNotifications = new Array();
                    missedNotificationsFromHost.map((missedNotificationString) => {
                        let missedNotification = null;
                        try {
                            missedNotification = JSON.parse(missedNotificationString);
                            if (missedNotification) {
                                missedNotifications.push(missedNotification);
                            }
                        }
                        catch (ex) {
                            Measures.logEvent(dashboard, "FeedProviderApiFailure", 16777216 /* productAndServicePerformance */, {
                                exception: ex,
                                feedProviderDefinitionId: feedDefinitionId,
                                reason: "GetMissedFeedNotificationsAsync unparsable json",
                            });
                        }
                    });
                    resolve(missedNotifications);
                }));
            });
        }
        return [];
    }
    // Tell the host that a feed provider was enabled or disabled.
    async enableHostFeedProviderAsync(feedProviderDefinitionId, isEnabled) {
        if (this._feedProviderApi) {
            // Fetch the feed provider id's that are enabled
            await this._feedProviderApi.EnableFeedProviderAsync(feedProviderDefinitionId, isEnabled);
        }
    }
    // Tell the host that a feed's notifications were enabled or disabled.
    async setFeedNotificationsEnabledAsync(feedProviderDefinitionId, feedDefinitionId, isEnabled) {
        // Get the version of the API that implements the Feed Notification code
        var feedProviderApi = (await tryGetHostApi("FeedProvider", 3, 3));
        if (!!feedProviderApi) {
            await feedProviderApi.EnableFeedNotificationsAsync(feedProviderDefinitionId, feedDefinitionId, isEnabled);
        }
    }
    async updateFeedProviderAsync(feedProvider) {
        let feedsAdded = [];
        let feedsRemoved = [];
        let feedsChanged = [];
        let isNewProvider = false;
        // Set the enabled state of the incomming updated provider registration
        feedProvider.enabled = this.feedProviderIsEnabled(feedProvider.id);
        // If the feed provider is not known this is an add all
        const existingProvider = this._feedProviderRegistrations.get(feedProvider.id);
        if (!existingProvider) {
            // Feeds contained in this new version if it is enabled
            if (feedProvider.enabled) {
                let newFeeds = await this.getHostFeedsAsync(feedProvider.id);
                newFeeds.map((feed) => {
                    if (isFeatureEnabled("Feature_3PAEP")) {
                        const addFeed = () => {
                            this._feedRegistrations.set(feed.id, feed);
                            feedsAdded.push(feed.id);
                            if (!this._activeFeedsOrder.includes(feed.id)) {
                                this._activeFeedsOrder.push(feed.id);
                                window.localStorage.setItem("activeFeedsOrder", JSON.stringify(this._activeFeedsOrder));
                            }
                        };
                        this.getHostMissedFeedNotificationsAsync(feed.id).then((missedNotifications) => {
                            feed.missedNotifications = missedNotifications;
                            addFeed();
                        }, (error) => {
                            addFeed();
                        });
                    }
                    else {
                        this._feedRegistrations.set(feed.id, feed);
                        feedsAdded.push(feed.id);
                        if (!this._activeFeedsOrder.includes(feed.id)) {
                            this._activeFeedsOrder.push(feed.id);
                            window.localStorage.setItem("activeFeedsOrder", JSON.stringify(this._activeFeedsOrder));
                        }
                    }
                });
            }
            isNewProvider = true;
        }
        else {
            // Collect the feeds new and removed
            // Feeds we already know about from this provider
            let existingFeeds = [...this._feedRegistrations.values()].filter((registration) => registration.providerId === feedProvider.id);
            // Feeds registered with this provider
            // If the provider is disabled return no feeds available from this provider, this will result in removed events
            let newFeeds = feedProvider.enabled ? await this.getHostFeedsAsync(feedProvider.id) : [];
            if (newFeeds) {
                newFeeds.map((feed) => {
                    // If this feed is already known, this is an update
                    if (this._feedRegistrations.has(feed.id)) {
                        const existingFeed = this._feedRegistrations.get(feed.id);
                        if (!deepCompare(feed, existingFeed)) {
                            feedsChanged.push(feed.id);
                        }
                    }
                    else {
                        // If this feed is not known, this is an add
                        feedsAdded.push(feed.id);
                        if (!this._activeFeedsOrder.includes(feed.id)) {
                            this._activeFeedsOrder.push(feed.id);
                            window.localStorage.setItem("activeFeedsOrder", JSON.stringify(this._activeFeedsOrder));
                        }
                    }
                    // Add or update the feed
                    if (isFeatureEnabled("Feature_3PAEP")) {
                        this.getHostMissedFeedNotificationsAsync(feed.id).then((missedNotifications) => {
                            feed.missedNotifications = missedNotifications;
                            this._feedRegistrations.set(feed.id, feed);
                        }, (error) => {
                            this._feedRegistrations.set(feed.id, feed);
                        });
                    }
                    else {
                        this._feedRegistrations.set(feed.id, feed);
                    }
                });
            }
            existingFeeds.map((existingFeed) => {
                // Is the existing feed still a member of the new feeds
                let stillValidFeed = newFeeds.some((newFeed) => newFeed.id === existingFeed.id);
                // If if the existing feed was not found in the newFeeds it was removed
                if (!stillValidFeed) {
                    // This feed was previously known in the provider but is no longer provided by it, this is a remove
                    feedsRemoved.push(existingFeed.id);
                    this._feedRegistrations.delete(existingFeed.id);
                    this._activeFeedsOrder = this._activeFeedsOrder.filter((id) => id !== existingFeed.id);
                    window.localStorage.setItem("activeFeedsOrder", JSON.stringify(this._activeFeedsOrder));
                }
            });
        }
        // Add/Replace the registration object if deepCompare is != or if it is new
        if (existingProvider && !deepCompare(feedProvider, existingProvider)) {
            this.notifyFeedProviderModelEvent("changed", feedProvider.id);
        }
        else if (isNewProvider) {
            this._feedProviderRegistrations.set(feedProvider.id, feedProvider);
            this.notifyFeedProviderModelEvent("added", feedProvider.id);
        }
        // If anything was addded or removed, notify that the list of feeds has changed.  Report all enabled feeds.
        if (feedsRemoved.length || feedsAdded.length) {
            let feedIds = this.getEnabledFeeds().map((feedRegistration) => feedRegistration.id);
            // Report the list of enebled feeds even when empty
            this.notifyFeedModelEvent("listChanged", feedIds);
        }
        // Notify removed, then added, then changed lists
        if (feedsRemoved.length) {
            this.notifyFeedModelEvent("removed", feedsRemoved);
        }
        if (feedsAdded.length) {
            this.notifyFeedModelEvent("added", feedsAdded);
        }
        if (feedsChanged.length) {
            this.notifyFeedModelEvent("changed", feedsChanged);
        }
    }
    SendActiveProviderToHost(activePivot) {
        if (this._feedProviderApi && activePivot != undefined) {
            let feedRegistration = this.getFeedRegistration(activePivot);
            let providerId = feedRegistration === null || feedRegistration === void 0 ? void 0 : feedRegistration.providerId;
            if (providerId != undefined) {
                this._feedProviderApi.SetActiveFeedAsync(providerId, activePivot).then(() => {
                    Trace.logEvent(dashboard, "ActiveFeedProvider", 1 /* information */, {
                        feedId: activePivot,
                        providerId: providerId,
                    });
                });
            }
        }
    }
    notifyFeedModelEvent(eventName, feedDefinitionIds) {
        for (let index = 0; index < this._feedEventListeners.length; index++) {
            this._feedEventListeners[index](eventName, feedDefinitionIds);
        }
    }
    notifyFeedProviderModelEvent(eventName, feedProviderDefinitionId) {
        for (let index = 0; index < this._feedProviderEventListeners.length; index++) {
            this._feedProviderEventListeners[index](eventName, feedProviderDefinitionId);
        }
    }
    getWidgetsBoardIcon() {
        return (this._isDarkTheme) ? widgetsBoardIconDark : widgetsBoardIconLight;
    }
    async AddWidgetsBoard() {
        // Fixed widget board provider, only added under Feature_BoardsLite
        const feedIcon = this.getWidgetsBoardIcon();
        const widgetsBoardProvider = {
            appId: widgetsBoardId,
            canBeDisabled: false,
            description: getResources().WidgetsOnlyBoard_DisplayName,
            displayName: getResources().WidgetsOnlyBoard_DisplayName,
            enabled: true,
            icon: feedIcon,
            id: widgetsBoardId,
            settingsUri: "",
        };
        const widgetsBoardFeed = {
            appId: widgetsBoardId,
            contentUri: "",
            description: getResources().WidgetsOnlyBoard_DisplayName,
            displayName: getResources().WidgetsOnlyBoard_DisplayName,
            id: widgetsBoardId,
            providerIcon: feedIcon,
            providerId: widgetsBoardId,
            missedNotifications: [],
            notifications: true,
        };
        this._feedProviderRegistrations.set(widgetsBoardProvider.id, widgetsBoardProvider);
        if (isFeatureEnabled("Feature_3PAEP")) {
            await this.getHostMissedFeedNotificationsAsync(widgetsBoardFeed.id).then((missedNotifications) => {
                widgetsBoardFeed.missedNotifications = missedNotifications;
                this._feedRegistrations.set(widgetsBoardFeed.id, widgetsBoardFeed);
            }, (error) => {
                this._feedRegistrations.set(widgetsBoardFeed.id, widgetsBoardFeed);
            });
        }
        else {
            this._feedRegistrations.set(widgetsBoardFeed.id, widgetsBoardFeed);
        }
    }
}
